import React from "react";
import { Link } from "react-router-dom";
import {
  AI_ASSIST_IMPORTS,
  AI_ASSIST_PAGE,
  AI_ASSIST_STRIP_HEADING,
} from "../../utility/aiAssistCopy";
import { PRODUCT_SCREENSHOTS } from "../ProductPages/productScreenshots";

const AiAssistStrip = () => (
  <section className="bg-brand-cream" aria-labelledby="ai-assist-heading">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-20 pb-4">
      <p className="font-display tracking-widest uppercase text-sm text-brand-gold-ink">
        AI Assist
      </p>
      <h2
        id="ai-assist-heading"
        className="heading-display text-3xl md:text-4xl mt-3"
      >
        {AI_ASSIST_STRIP_HEADING}
      </h2>
      <div className="mt-3 h-1 w-12 bg-brand-gold" aria-hidden="true" />
      <p className="mt-4 text-brand-muted max-w-2xl">
        A photo or PDF of a league sheet, paper signup sheet, or recap sheet.
        You review the rows before they are used.
      </p>
      <ul className="mt-10 space-y-12">
        {AI_ASSIST_IMPORTS.map((row) => {
          const shot = PRODUCT_SCREENSHOTS[row.shotKey];
          return (
            <li
              key={row.id}
              className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-start"
            >
              <div>
                <h3 className="font-display font-bold tracking-tight text-2xl text-brand-charcoal">
                  <Link to={row.to} className="underline text-brand-gold-ink">
                    {row.label}
                  </Link>
                </h3>
                <div className="mt-3 h-1 w-12 bg-brand-gold" aria-hidden="true" />
                <p className="mt-4 text-brand-charcoal leading-relaxed">
                  {row.heading}
                </p>
                <p className="mt-2 text-brand-muted leading-relaxed">{row.fix}</p>
              </div>
              {shot ? (
                <figure className="card-board overflow-hidden">
                  <img
                    src={shot.src}
                    alt={shot.alt}
                    className="w-full h-auto bg-white"
                    width={1600}
                    height={1000}
                  />
                </figure>
              ) : null}
            </li>
          );
        })}
      </ul>
      <p className="mt-10">
        <Link
          to={AI_ASSIST_PAGE.to}
          className="text-sm underline text-brand-gold-ink"
        >
          How AI Assist works
        </Link>
      </p>
    </div>
  </section>
);

export default AiAssistStrip;
